<div mat-dialog-content>
    <ag-grid-angular
            style="width: 75vw; height: 60vh;"
            class="ag-theme-alpine"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [rowData]="rowData$ | async"
            [rowSelection]="'multiple'"
            [enableRtl]="true"
            [pinnedTopRowData]="pinnedTopRowData"
            [animateRows]="true"
            (gridReady)="onGridReady($event)"
            (firstDataRendered)="onFirstDataRendered($event)"
            (cellClicked)="onCellClicked($event)">
    </ag-grid-angular>
</div>
<div mat-dialog-actions>
    <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">

        <button mat-raised-button color="warn" (click)="close()">Cancel</button>
    </div>
</div>
